import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { loginUser, checkSubscription } from './authAPI';

import initialState from './initialState';

// pgw 29-oct-2025
let doprint = false;
// let doprint = true;



// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const loginUserAsync = createAsyncThunk(
  'auth/loginUser',
  async (creds, thunkAPI) => {
    const endpoint = thunkAPI.getState().ui.clientConfig.features.auth.endpoint;
    const response = await loginUser(endpoint, creds.username, creds.password);
    // The value we return becomes the `fulfilled` action payload
    return {
      user: response.data,
      credentials: creds
    }
  }
);

export const setSubscribedAsync = createAsyncThunk(
  'auth/checkSubscription',
  async (payload, thunkAPI) => {


    const endpoint = thunkAPI.getState().ui.clientConfig.features.auth.domainCookie.userInfoUrl;

	if (doprint) console.log('setSubscribedAsync endpoint = ', endpoint);
	if (doprint) console.log('setSubscribedAsync payload = ', payload);

    const response = await checkSubscription(endpoint, payload);

	if (doprint) console.log('setSubscribedAsync response = ', response);

    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

// config.INITIAL_AUTH_STATE ? config.INITIAL_AUTH_STATE : 

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    logout: (state, action) => {
      if (action.payload?.user) {
        state.user = action.payload.user;
      } else {
        state.user = null
      }
      state.credentials = null;
      state.errorMessage = null;
      state.status = 'fulfilled';
    },
    setAuth: (state, action) => {
      state.status = action.payload.status;
      state.errorMessage = action.payload.errorMessage;
      state.credentials = action.payload.credentials;
      state.user = action.payload.user;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loginUserAsync.pending, (state) => {
        state.status = 'pending';
        state.errorMessage = null;
      })
      .addCase(loginUserAsync.rejected, (state, action) => {

        state.status = 'rejected';
        state.errorMessage = action.error.message;
        state.user = null;
      })
      .addCase(loginUserAsync.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        state.errorMessage = null;
        state.credentials = action.payload.credentials;
        state.user = action.payload.user;
      })
      .addCase(setSubscribedAsync.pending, (state) => {
        state.status = 'pending';
        state.errorMessage = null;
      })
      .addCase(setSubscribedAsync.rejected, (state, action) => {
        if (doprint) console.log(action);
        state.status = 'rejected';
        // state.errorMessage = action.error.message;
        // state.user = null;
      })
      .addCase(setSubscribedAsync.fulfilled, (state, action) => {
        if (doprint) console.log(action.payload);
        state.status = 'fulfilled';
        if (!state.user) state.user = {};
        state.user.subscribed = action.payload.subscribed? true: false;
        state.user.displayName = action.payload.userName;
        state.user.guest = false;
        if (doprint) console.log('subscibed call fulfilled', action);
      });
  },
});

export const { logout, setAuth } = authSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectUser = (state, thunkAPI) => {
  return state.auth.user
};
export const selectCredentials = (state) => state.auth.credentials;
export const selectStatus = (state) => state.auth.status;
export const selectErrorMessage = (state) => state.auth.errorMessage;

// // We can also write thunks by hand, which may contain both sync and async logic.
// // Here's an example of conditionally dispatching actions based on current state.
// export const incrementIfOdd = (amount) => (dispatch, getState) => {
//   const currentValue = selectCount(getState());
//   if (currentValue % 2 === 1) {
//     dispatch(incrementByAmount(amount));
//   }
// };

export default authSlice.reducer;
